/* =====================================================
   PGJ SEO read-more toggle (footer & section)
   ===================================================== */
(function () {
  'use strict';

  function cleanSeo(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.pgj-seo-body .header-toggle'), function (link) {
      link.remove();
    });
    Array.prototype.forEach.call(root.querySelectorAll('.pgj-seo-toggle'), function (btn) {
      btn.dataset.pgjSeoReady = 'true';
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.pgj-seo-toggle');
    if (!btn) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var body = document.getElementById(btn.getAttribute('data-target'));
    if (!body) return;

    var expanded = body.classList.contains('pgj-seo-collapsed');
    body.classList.toggle('pgj-seo-collapsed', !expanded);
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var label = btn.querySelector('span');
    if (label) label.textContent = expanded ? 'Lebih sedikit' : 'Selengkapnya';
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { cleanSeo(document); });
  } else {
    cleanSeo(document);
  }

  document.addEventListener('shopify:section:load', function (event) { cleanSeo(event.target); });
})();

/* =====================================================
   PGJ EFFECTS — scroll reveal
   ===================================================== */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function init(scope) {
    scope = scope || document;

    /* Reveal halus untuk konten di bawah lipatan. */
    if (!('IntersectionObserver' in window)) {
      return;
    }
    if (!init.io) {
      init.io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('pgj-inview');
              init.io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px 40px 0px' }
      );
    }
    var els = scope.querySelectorAll(
      '#content .shopify-section, #content .product-card, #content .l4ft > li'
    );
    Array.prototype.forEach.call(els, function (el) {
      if (el.classList.contains('pgj-reveal') || el.classList.contains('pgj-inview')) {
        return;
      }
      var rect = el.getBoundingClientRect();
      if (rect.top > window.innerHeight) {
        el.classList.add('pgj-reveal');
        init.io.observe(el);
      }
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    init(document);
  });

  /* theme editor: section baru yang di-load ikut diproses */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

/* =====================================================
   PGJ product accordion — buka/tutup smooth (Jadwal
   Pengiriman, Garansi, dsb.)
   ===================================================== */
(function () {
  'use strict';

  var EASE = 'height 0.5s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s ease, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animateClose(det, body) {
    var startH = body.scrollHeight;
    body.style.height = startH + 'px';
    body.style.opacity = '1';
    body.style.transform = 'translateY(0)';
    body.style.overflow = 'hidden';
    body.style.willChange = 'height, opacity, transform';
    body.style.transition = EASE;
    // force reflow
    body.offsetHeight;
    requestAnimationFrame(function () {
      body.style.height = '0px';
      body.style.opacity = '0';
      body.style.transform = 'translateY(-6px)';
    });
    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onEnd);
      det.open = false;
      body.style.height = '';
      body.style.opacity = '';
      body.style.transform = '';
      body.style.overflow = '';
      body.style.willChange = '';
      body.style.transition = '';
      det.dataset.pgjAccBusy = '';
    };
    body.addEventListener('transitionend', onEnd);
    // fallback jika transition tidak fire (misal height 0)
    setTimeout(function () {
      if (det.dataset.pgjAccBusy === 'true' && !det.open) onEnd({ propertyName: 'height' });
    }, 600);
  }

  function animateOpen(det, body) {
    det.open = true;
    body.style.height = '0px';
    body.style.opacity = '0';
    body.style.transform = 'translateY(-6px)';
    body.style.overflow = 'hidden';
    body.style.willChange = 'height, opacity, transform';
    body.style.transition = EASE;
    var endH = body.scrollHeight;
    body.offsetHeight;
    requestAnimationFrame(function () {
      body.style.height = endH + 'px';
      body.style.opacity = '1';
      body.style.transform = 'translateY(0)';
    });
    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onEnd);
      body.style.height = '';
      body.style.opacity = '';
      body.style.transform = '';
      body.style.overflow = '';
      body.style.willChange = '';
      body.style.transition = '';
      det.dataset.pgjAccBusy = '';
    };
    body.addEventListener('transitionend', onEnd);
    setTimeout(function () {
      if (det.dataset.pgjAccBusy === 'true' && det.open) onEnd({ propertyName: 'height' });
    }, 600);
  }

  function initAccordions(scope) {
    var items = (scope || document).querySelectorAll('.accordion-a details');
    Array.prototype.forEach.call(items, function (det) {
      if (det.dataset.pgjAccReady === 'true') {
        return;
      }
      var summary = det.querySelector(':scope > summary');
      var body = det.querySelector(':scope > div');
      if (!summary || !body) {
        return;
      }
      det.dataset.pgjAccReady = 'true';
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (det.dataset.pgjAccBusy === 'true') {
          return;
        }
        if (reduceMotion.matches) {
          det.open = !det.open;
          return;
        }
        det.dataset.pgjAccBusy = 'true';
        if (det.open) {
          animateClose(det, body);
        } else {
          animateOpen(det, body);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordions(document);
    });
  } else {
    initAccordions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAccordions(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initAccordions(event.target);
  });
})();

/* =====================================================
   PGJ product specifications — "Label: value" to table
   ===================================================== */
(function () {
  'use strict';

  function parseLine(paragraph) {
    var text = paragraph.textContent.replace(/\s+/g, ' ').trim();
    var separator = text.indexOf(':');
    if (separator < 1) return null;

    var label = text.slice(0, separator).trim();
    var value = text.slice(separator + 1).trim();
    if (!value || label.length > 40 || /[.!?]$/.test(label)) return null;
    return { label: label, value: value };
  }

  function formatSpecificationPanel(panel) {
    var paragraphs = Array.prototype.slice.call(panel.querySelectorAll(':scope > p'));
    var activeList = null;

    paragraphs.forEach(function (paragraph) {
      var text = paragraph.textContent.replace(/\s+/g, ' ').trim();
      if (!text) {
        paragraph.remove();
        return;
      }

      if (/^[•·]\s*/.test(text)) {
        if (!activeList) {
          activeList = document.createElement('ul');
          activeList.className = 'pgj-spec-list';
          paragraph.parentNode.insertBefore(activeList, paragraph);
        }
        var item = document.createElement('li');
        item.textContent = text.replace(/^[•·]\s*/, '');
        activeList.appendChild(item);
        paragraph.remove();
        return;
      }

      activeList = null;
      if (/^[^:]{2,50}:$/.test(text) || (/^[A-Z0-9\s]+:$/.test(text) && text.length <= 50)) {
        var heading = document.createElement('h3');
        heading.className = 'pgj-spec-heading';
        heading.textContent = text.replace(/:$/, '');
        paragraph.replaceWith(heading);
        return;
      }

      var parsed = parseLine(paragraph);
      if (parsed) {
        paragraph.className = 'pgj-spec-line';
        paragraph.textContent = '';
        var label = document.createElement('strong');
        label.textContent = parsed.label + ':';
        var value = document.createElement('span');
        value.textContent = parsed.value;
        paragraph.appendChild(label);
        paragraph.appendChild(value);
      }
    });
  }

  function initSpecifications(scope) {
    var descriptions = (scope || document).querySelectorAll('.m6tb .tabs-inner .m6lm:not([data-pgj-spec-ready])');
    Array.prototype.forEach.call(descriptions, function (description) {
      var paragraphs = Array.prototype.slice.call(description.children).filter(function (node) {
        return node.tagName === 'P';
      });
      var specificationMarker = paragraphs.find(function (paragraph) {
        return /^spesifikasi\s*:\s*$/i.test(paragraph.textContent.replace(/\s+/g, ' ').trim());
      });
      var index = 0;

      while (index < paragraphs.length) {
        var rows = [];
        var cursor = index;
        while (cursor < paragraphs.length) {
          var parsed = parseLine(paragraphs[cursor]);
          if (!parsed) break;
          rows.push({ paragraph: paragraphs[cursor], data: parsed });
          cursor++;
        }

        if (rows.length >= 2) {
          var table = document.createElement('table');
          table.className = 'pgj-spec-table';
          var tbody = document.createElement('tbody');
          rows.forEach(function (row) {
            var tr = document.createElement('tr');
            var th = document.createElement('th');
            var td = document.createElement('td');
            th.scope = 'row';
            th.textContent = row.data.label;
            td.textContent = row.data.value;
            tr.appendChild(th);
            tr.appendChild(td);
            tbody.appendChild(tr);
          });
          table.appendChild(tbody);
          rows[0].paragraph.parentNode.insertBefore(table, rows[0].paragraph);
          rows.forEach(function (row) { row.paragraph.remove(); });
        }
        index = cursor > index ? cursor : index + 1;
      }

      var tables = description.querySelectorAll(':scope > .pgj-spec-table');
      if (!tables.length && !specificationMarker) return;
      description.dataset.pgjSpecReady = 'true';

      var tabs = document.createElement('div');
      tabs.className = 'pgj-description-tabs';
      tabs.setAttribute('role', 'tablist');
      tabs.setAttribute('aria-label', 'Informasi produk');

      var descriptionButton = document.createElement('button');
      descriptionButton.type = 'button';
      descriptionButton.className = 'pgj-description-tab active';
      descriptionButton.setAttribute('role', 'tab');
      descriptionButton.setAttribute('aria-selected', 'true');
      descriptionButton.textContent = 'Deskripsi';

      var specificationButton = document.createElement('button');
      specificationButton.type = 'button';
      specificationButton.className = 'pgj-description-tab';
      specificationButton.setAttribute('role', 'tab');
      specificationButton.setAttribute('aria-selected', 'false');
      specificationButton.textContent = 'Spesifikasi';

      var specificationPanel = document.createElement('div');
      specificationPanel.className = 'pgj-spec-panel';
      specificationPanel.setAttribute('role', 'tabpanel');
      specificationPanel.hidden = true;

      if (specificationMarker) {
        var specificationNodes = [];
        var node = specificationMarker.nextSibling;
        while (node) {
          specificationNodes.push(node);
          node = node.nextSibling;
        }
        specificationMarker.remove();
        specificationNodes.forEach(function (item) { specificationPanel.appendChild(item); });
      } else {
        Array.prototype.forEach.call(tables, function (table) { specificationPanel.appendChild(table); });
      }
      formatSpecificationPanel(specificationPanel);

      tabs.appendChild(descriptionButton);
      tabs.appendChild(specificationButton);
      description.parentNode.insertBefore(tabs, description);
      description.parentNode.insertBefore(specificationPanel, description.nextSibling);

      function selectTab(showSpecifications) {
        description.hidden = showSpecifications;
        specificationPanel.hidden = !showSpecifications;
        descriptionButton.classList.toggle('active', !showSpecifications);
        specificationButton.classList.toggle('active', showSpecifications);
        descriptionButton.setAttribute('aria-selected', showSpecifications ? 'false' : 'true');
        specificationButton.setAttribute('aria-selected', showSpecifications ? 'true' : 'false');
      }

      descriptionButton.addEventListener('click', function () { selectTab(false); });
      specificationButton.addEventListener('click', function () { selectTab(true); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSpecifications(document); });
  } else {
    initSpecifications(document);
  }
  window.addEventListener('load', function () { initSpecifications(document); });
  document.addEventListener('shopify:section:load', function (event) { initSpecifications(event.target); });
})();

/* =====================================================
   PGJ search placeholder — type & delete animation
   ===================================================== */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PHRASES = [
    'Tag Heuer Senna',
    'Tissot PRX',
    'Maurice Lacroix Aikon',
    'Seiko 5 Sports',
    'Bell & Ross',
    'Versace Hellenyium',
    'Panerai Luminor',
    'Tudor Black Bay'
  ];
  var PREFIX = '';
  var TYPE_SPEED = 75;
  var DELETE_SPEED = 38;
  var HOLD_TYPED = 1600;
  var HOLD_EMPTY = 500;

  function init() {
    var input = document.getElementById('search_main');
    if (!input || input.dataset.pgjPhReady === 'true') return;
    input.dataset.pgjPhReady = 'true';
    var original = input.getAttribute('placeholder') || '';
    var idx = 0;
    var pos = 0;
    var deleting = false;
    var timer = null;
    var paused = false;
    var showPipe = true;
    var baseText = '';

    setInterval(function () { showPipe = !showPipe; if (!paused && document.activeElement !== input && !input.value) input.setAttribute('placeholder', baseText + (showPipe ? '│' : ' ')); }, 530);

    function tick() {
      if (paused || document.activeElement === input || input.value) {
        timer = setTimeout(tick, 300);
        return;
      }
      var phrase = PHRASES[idx];
      var full = PREFIX + phrase;
      if (!deleting) {
        pos++;
        baseText = full.slice(0, pos);
        input.setAttribute('placeholder', baseText + '│');
        if (pos >= full.length) {
          deleting = true;
          timer = setTimeout(tick, HOLD_TYPED);
        } else {
          var jitter = Math.random() * 30;
          timer = setTimeout(tick, TYPE_SPEED + jitter);
        }
      } else {
        pos--;
        baseText = full.slice(0, pos);
        input.setAttribute('placeholder', baseText + '│');
        if (pos <= PREFIX.length) {
          deleting = false;
          idx = (idx + 1) % PHRASES.length;
          timer = setTimeout(tick, HOLD_EMPTY);
        } else {
          timer = setTimeout(tick, DELETE_SPEED);
        }
      }
    }

    function pause() {
      paused = true;
      if (timer) clearTimeout(timer);
      input.setAttribute('placeholder', original);
    }

    function resume() {
      if (input.value) return;
      paused = false;
      pos = PREFIX.length;
      deleting = false;
      // mulai dari phrase berikutnya biar tidak mengulang
      timer = setTimeout(tick, 400);
    }

    input.addEventListener('focus', pause);
    input.addEventListener('input', function () {
      if (input.value) pause();
      else resume();
    });
    input.addEventListener('blur', function () {
      if (!input.value) resume();
    });

    // start
    pos = PREFIX.length;
    input.setAttribute('placeholder', PREFIX);
    timer = setTimeout(tick, 700);

    // pause saat tab tidak aktif biar tidak lompat
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        paused = true;
        if (timer) clearTimeout(timer);
      } else if (!input.value && document.activeElement !== input) {
        paused = false;
        timer = setTimeout(tick, 600);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(); });
})();
